import React from 'react';
import { Theme } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons/dist/theme/config/colors';
import { createStyles, makeStyles } from '@mui/styles';

interface Props {
  color?: string;
}

const styles = ({ shape }: Theme) =>
  createStyles<string, Props>({
    root: {
      backgroundColor: ({ color }) => color,
      border: `1px solid ${colorPalette.grey.main}`,
      borderRadius: shape.borderRadius,
      flexBasis: 20,
      flexGrow: 0,
      flexShrink: 0,
      height: 20,
      width: 20,
    },
  });

const useStyles = makeStyles(styles);

export function ColorSample({ color = 'transparent' }: Props): React.ReactElement {
  const classes = useStyles({ color });

  return <div className={classes.root} />;
}
